import React, { useState } from 'react';
import { Alert, Button, Modal, Spin, Tooltip } from 'antd';
import { ExportOutlined } from '@ant-design/icons';

const RDF_LOCATION_PART = 'o/semanticpro-openapi/v1.0/ttl';
const TURTLE_CONTENT_TYPE = 'text/turtle';
const NO_RDF_MESSAGE = 'RDF содержимое отсутствует.';
const NO_SETTINGS_MESSAGE = 'Отсутствует настройка получения RDF содержимого.';

const isTurtleContent = (contentType) => {
  return contentType && contentType.toLowerCase().indexOf(TURTLE_CONTENT_TYPE) >= 0;
}

const resolveLocation = (location, baseUri) => {
  if (!location) return '';

  try {
    return new URL(location, baseUri).toString();
  } catch (e) {
    return location;
  }
}

/**
 * Исправление ошибки
 * 
 * Mixed Content: The page at 'https://statcat.semanticpro.org/... ' was loaded over HTTPS, 
 * but requested an insecure resource 'http://purl.semanticpro.org/authority/kind-agent'. 
 * This request has been blocked; the content must be served over HTTPS.
 * 
 */
const toFetchablePurl = (uri) => {
  if (!uri) return uri;

  if (
    window.location.protocol === 'https:' &&
    uri.startsWith('http://purl.')
  ) {
    return uri.replace('http://purl.', 'https://purl.');
  }

  return uri;
}

const fetchRdf = (uri) => {
  const requestOptions = {
    method: 'GET',
    headers: { 
      // 'Content-type': TURTLE_CONTENT_TYPE,
      Accept: TURTLE_CONTENT_TYPE,
      // Origin: window.location.origin,
    },
    credentials: 'omit',
    mode: 'cors',
    redirect: 'follow' //manual',
  };

  return fetch(uri, requestOptions)
    // .then(response => {
    //   const rawLocation = response.headers.get('Location');
    //   const location = resolveLocation(rawLocation, uri);

    //   if (location === uri || rawLocation === uri) {
    //     return { type: 'message', content: NO_SETTINGS_MESSAGE };
    //   }

    //   if (!location || location.indexOf(RDF_LOCATION_PART) < 0) {
    //     return { type: 'message', content: NO_RDF_MESSAGE };
    //   }
    //   console.log("!!!!!!!!!!", location, requestOptions);
    //   return fetch(location, {
    //     ...requestOptions,
    //     redirect: 'follow',
    //   });
    // })
    .then(response => {
      if (!response || response.type === 'message') return response;

      const contentType = response.headers.get('Content-Type');
      if (!isTurtleContent(contentType)) {
        return { type: 'message', content: NO_RDF_MESSAGE };
      }

      return response.text().then(text => ({ type: 'rdf', content: text }));
    });
}

/** Ссылка на URI. Включает ссылку открытя в текущем окне Внешние (активные линки) */
export const URILink = ({uri}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [rdfContent, setRdfContent] = useState('');
  const [message, setMessage] = useState('');

  const showRdfModal = (e) => {
    e.preventDefault();

    setModalOpen(true);
    setLoading(true);
    setRdfContent('');
    setMessage('');

    fetchRdf(toFetchablePurl(uri))
      .then(result => {
        if (result.type === 'rdf') {
          setRdfContent(result.content);
          return;
        }

        setMessage(result.content);
      })
      .catch(error => {
        setMessage(`${NO_RDF_MESSAGE} ${error.message || error}`);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  return (
    <p>
        <a href={uri}>{uri}</a>&nbsp;
        <Tooltip placement="top" title={"Просмотр в формате RDF"}>
          <Button icon={<ExportOutlined />} shape="circle" size="small" onClick={showRdfModal} />
        </Tooltip>
        <Modal
          style={{minWidth: "80%"}}
          open={modalOpen}
          title="RDF содержимое"
          cancelText="Закрыть"
          okText="Ок"
          onCancel={() => setModalOpen(false)}
          onOk={() => setModalOpen(false)}
          cancelButtonProps={{ disabled: true, style: { display: "none" }}}
          destroyOnHidden
          okButtonProps={{ disabled: loading }}
        >
          {loading && <Spin />}
          {!loading && message && <Alert type="warning" message={message} />}
          {!loading && rdfContent &&
            <pre style={{whiteSpace: 'pre-wrap', overflowWrap: 'anywhere', maxHeight: '65vh', overflow: 'auto'}}>
              {rdfContent}
            </pre>
          }
        </Modal>
    </p>
  )
}

export default URILink;

